import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SclUtilFilterService {

  constructor() { }

  arrayFilter(obj, arg1) {
    if (obj && Array.isArray(obj) && String(arg1) !== 'undefined') {
      const newArray = obj.map(( el ) => {
        return el[arg1];
      });
      return newArray.toString();
    }  else {
      if (Array.isArray(obj)) {
        return obj.toString();
      } else {
        return obj;
      }
    }
  }
}
